export default __webpack_public_path__ + "static/richard-f533967f28884dc04dd4f9ebd6836c9a.png";